import merge from "lodash/merge";
import { stringify } from "qs";
import superagentRequest from "superagent";

import api from "./api";
import { convertToPassBucketless } from "./PassUtil";
import config from "../config";

import { generateTrackingPayload } from "./tracking";

const RESERVATION_PERIOD_MS = 6 * 60 * 1000;

function fixOrder(order) {
  if (order.passes) {
    order.passes = order.passes.map(convertToPassBucketless);
  }

  return order;
}

export default {
  submit(order, person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders`,
          json: {
            order: {
              subitems: order.subitems.map(s => {
                if (order.gift) {
                  s.gift = true;
                }
                return s;
              }),
              do_not_email: order.do_not_email,
              coupon: order.coupon_code,
              pass: order.pass,
              reservation_token: order.reservation_token,
              guest_mode: order.guest_mode,
              guest_email: order.guest_email,
              guest_payment_token: order.guest_payment_token,
              with_credits: order.with_credits,
              include_itemized_summary: order.include_itemized_summary,
              tracking_data: generateTrackingPayload()
            },
            payment_intent: order.payment_intent,
            token: person,
            version: "1.1"
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(fixOrder(response));
        }
      );
    });
  },

  fetchAll(person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `person/self/orders`,
          qs: {
            token: person,
            conditions: { event_bucket: config.event_bucket }
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.orders.map(fixOrder));
        }
      );
    });
  },

  fetchOne(person, order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `orders/${order}`,
          qs: { token: person }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(fixOrder(response));
        }
      );
    });
  },

  downloadReceipt(person, order) {
    let query = stringify({
      token: person
    });

    window.open(
      config.endpoint + `orders/${order}/receipt.pdf?${query}`,
      "_blank"
    );
  },

  holdSeats(order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/create_reservation`,
          json: {
            event: order.event,
            seats: order.subitems.reduce(
              (all, s) => all.concat(s.seats || []),
              []
            )
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve({
            reservation_token: response.reservation_token,
            expiry: response.expiry
          });
        }
      );
    });
  },

  dropSeats(order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/cancel_reservation`,
          json: {
            token: order.reservation_token
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve();
        }
      );
    });
  },

  testPass(person, order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/test`,
          json: {
            token: person,
            event_bucket: order.event_bucket,
            pass: order.pass,
            order: JSON.stringify(order)
          }
        },
        function (err, response) {
          if (err) {
            return resolve({
              is_applicable: false,
              error: err.message || err
            });
          }

          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/OrderUtil.js